import React from "react";
import {AdminBriefs} from "./AdminBriefs.jsx";
import {TableDateSearchProvider} from "../Context/TableDateSearchContext.jsx";
import {ResponsiveView} from "../../components/index.jsx";
import {Devices} from "../../components/ResponsiveView/consts.js";

export const AdminBriefsWrapper = () => {
    return (
        <TableDateSearchProvider localStorageKey="adminBriefsSearchDate">
            <ResponsiveView devices={[Devices.desktop, Devices.mobile]}>
                <AdminBriefs />
            </ResponsiveView>
        </TableDateSearchProvider>
    );
};
